import AddWhite from './add-white.png';
import BackIcon from './back.png';
import CalendarIcon from './calendar.png';
import ChevronRightIcon from './chevron-right.png';
import CloseIcon from './close.png';
import DoneIcon from './done.png';
import DownloadIcon from './download.png';
import EditIcon from './edit.png';
import LocationIcon from './location.png';
import Menu1 from './menu/menu1.png';
import Menu10 from './menu/menu10.png';
import Menu10Active from './menu/menu10-active.png';
import Menu11 from './menu/menu11.png';
import Menu11Active from './menu/menu11-active.png';
import Menu1Active from './menu/menu1-active.png';
import Menu2 from './menu/menu2.png';
import Menu2Active from './menu/menu2-active.png';
import Menu3 from './menu/menu3.png';
import Menu3Active from './menu/menu3-active.png';
import Menu4 from './menu/menu4.png';
import Menu4Active from './menu/menu4-active.png';
import Menu5 from './menu/menu5.png';
import Menu5Active from './menu/menu5-active.png';
import Menu6 from './menu/menu6.png';
import Menu6Active from './menu/menu6-active.png';
import Menu7 from './menu/menu7.png';
import Menu7Active from './menu/menu7-active.png';
import Menu8 from './menu/menu8.png';
import Menu8Active from './menu/menu8-active.png';
import Menu9 from './menu/menu9.png';
import Menu9Active from './menu/menu9-active.png';
import MenuIcon from './menu.png';
import MenuLogoutIcon from './menu-logout.png';
import PasswordActive from './password-active.png';
import PasswordInactive from './password-inactive.png';
import PDFIcon from './pdf.png';
import ProfilePhotoIcon from './profile-photo.png';
import RightIcon from './right.png';
import SearchIcon from './search.png';
import ToggleOffIcon from './toggle-off.png';
import ToggleOnIcon from './toggle-on.png';
import TrashIcon from './trash.png';
import UploadFileIcon from './upload-file.png';
import ViewIcon from './view.png';
import TabClientsIcon from './tab-clients.png';
import TabDriversIcon from './tab-drivers.png';
import TabOwnersIcon from './tab-owners.png';
import TabModeratorsIcon from './tab-moderators.png';
import FormTab1Icon from './form-tab-1.png';
import FormTab2Icon from './form-tab-2.png';
import FormTab2ActiveIcon from './form-tab-2-active.png';
import PlaceholderCarIcon from './placeholder-car.png';
import PlaceholderUserIcon from './placeholder-user.png';
import UserMenuIcon from './user-menu.png';
import SettingsIcon from './settings.png';
import CameraIcon from './camera.png';
import XLSIcon from './xls.png';
import KPI11Icon from './kpi-1.png';
import KPI21Icon from './kpi-2.png';
import KPI31Icon from './kpi-3.png';
import KPI41Icon from './kpi-4.png';
import KPI51Icon from './kpi-5.png';
import KPI61Icon from './kpi-6.png';
import KPI71Icon from './kpi-7.png';
import KPI81Icon from './kpi-8.png';
import TagBlueIcon from './tag-blue.png';
import TagRedIcon from './tag-red.png';
import TagGreenIcon from './tag-green.png';
import TagOrangeIcon from './tag-orange.png';

const Menu = {
	Menu1,
	Menu1Active,
	Menu2,
	Menu2Active,
	Menu3,
	Menu3Active,
	Menu4,
	Menu4Active,
	Menu5,
	Menu5Active,
	Menu6,
	Menu6Active,
	Menu7,
	Menu7Active,
	Menu8,
	Menu8Active,
	Menu9,
	Menu9Active,
	Menu10,
	Menu10Active,
	Menu11,
	Menu11Active,
};

export {
	CameraIcon,
	AddWhite,
	BackIcon,
	CalendarIcon,
	ChevronRightIcon,
	CloseIcon,
	DoneIcon,
	DownloadIcon,
	EditIcon,
	LocationIcon,
	Menu,
	MenuIcon,
	MenuLogoutIcon,
	PasswordActive,
	PasswordInactive,
	PDFIcon,
	ProfilePhotoIcon,
	RightIcon,
	SearchIcon,
	ToggleOffIcon,
	ToggleOnIcon,
	TrashIcon,
	UploadFileIcon,
	ViewIcon,
	TabClientsIcon,
	TabDriversIcon,
	TabOwnersIcon,
	TabModeratorsIcon,
	FormTab1Icon,
	FormTab2Icon,
	FormTab2ActiveIcon,
	PlaceholderCarIcon,
	PlaceholderUserIcon,
	UserMenuIcon,
	SettingsIcon,
	XLSIcon,
	KPI11Icon,
	KPI21Icon,
	KPI31Icon,
	KPI41Icon,
	KPI51Icon,
	KPI61Icon,
	KPI71Icon,
	KPI81Icon,
	TagBlueIcon,
	TagRedIcon,
	TagGreenIcon,
	TagOrangeIcon,
};
